import { render, staticRenderFns } from "./ModalNewSpendType.vue?vue&type=template&id=7176f466&scoped=true"
import script from "./ModalNewSpendType.vue?vue&type=script&lang=js"
export * from "./ModalNewSpendType.vue?vue&type=script&lang=js"
import style0 from "./ModalNewSpendType.vue?vue&type=style&index=0&id=7176f466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7176f466",
  null
  
)

export default component.exports